import { ToastContainer } from 'react-toastify';

import withProviders from '@/app/providers';
import { DialogProvider } from '@/app/providers/modal-provider/modal-provider.tsx';
import { ThemeProvider } from '@/app/providers/theme-provider';
import Routing from '@/pages';
import ChatWrapper from '@/shared/ui/chat/components/chat-wrapper/chat-wrapper';

const showChat = import.meta.env.VITE_SHOW_CHAT === 'true';
const checkBalance = import.meta.env.VITE_CHECK_BALANCE === 'true';

const App = () => {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <DialogProvider>
        <Routing />
        {showChat && <ChatWrapper />}
        {checkBalance && <ToastContainer />}
      </DialogProvider>
    </ThemeProvider>
  );
};

export default withProviders(App);
